import { render } from "./OrderDataView.vue?vue&type=template&id=bca12f78&scoped=true&ts=true"
import script from "./OrderDataView.vue?vue&type=script&lang=ts"
export * from "./OrderDataView.vue?vue&type=script&lang=ts"

import "./OrderDataView.vue?vue&type=style&index=0&id=bca12f78&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca12f78"]])

export default __exports__